export default __webpack_public_path__ + "static/media/CodeNext-ExtraBold.faeca9a2.ttf";